import { Pipe, PipeTransform } from '@angular/core';
import { AccessControlService } from 'src/app/core/access-control/access-control.service';

@Pipe({
    name: 'can',
    pure: true, // Pure pipe - only recalculates when input reference changes
    standalone: false
})
export class CanPipe implements PipeTransform {

    constructor(private _accessControl: AccessControlService) { }

    /**
     * @param capability - Capability key, e.g. Capability.BANK_ACCOUNTS.MANAGE_INTEGRATIONS
     * @returns true if the current user has access to this capability
     */
    transform(capability: string): boolean {
        return this._accessControl.can(capability);
    }
}
